import React, { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import ShadowSimulator from "leaflet-shadow-simulator";
import SunCalc from "suncalc"; 
import Accessibility from "../Accessiblity/Accessibility";

export default function SunpathMap() {
  const mapRef = useRef(null);
  const shadowRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [solarData, setSolarData] = useState({});
  const [coords, setCoords] = useState({ lat: null, lng: null });

  useEffect(() => {
    
    let defaultLat = 8.0855;
    let defaultLng = 78.145;

    const initMap = (lat, lng) => {
      if (mapRef.current) return;

      setCoords({ lat, lng });

      // Create Map
      mapRef.current = L.map("mapid").setView([lat, lng], 13);

      // Base Map Layer
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
      }).addTo(mapRef.current);

      // Create Shadow Simulator
      shadowRef.current = new ShadowSimulator({
        lat,
        lng,
        apiKey:"eyJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImxrcHJlbXBsb3llZTAxOEBnbWFpbC5jb20iLCJjcmVhdGVkIjoxNzU0ODkxMzA0NzU2LCJpYXQiOjE3NTQ4OTEzMDR9.D2eS_5l8YjejhhUvDRA9NQyxMkT_gyg968UhxxYtMlU",
        dateTime: new Date(),
        utcOffset: new Date().getTimezoneOffset() / -60,
        sunpath: true,
      });
      shadowRef.current.addTo(mapRef.current);

      // Toggle Sunpath Button
      const toggleButton = L.control({ position: "topright" });
      toggleButton.onAdd = () => {
        const btn = L.DomUtil.create("button", "leaflet-bar");
        btn.innerText = "Toggle Sunpath";
        btn.style.background = "#ff9800";
        btn.style.color = "#fff";
        btn.style.border = "none";
        btn.style.padding = "5px";
        btn.style.cursor = "pointer";
        btn.onclick = () => {
          if (shadowRef.current.isVisible()) {
            shadowRef.current.hide();
          } else {
            shadowRef.current.show();
          }
        };
        return btn;
      };
      toggleButton.addTo(mapRef.current);

      setLoading(false);
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => initMap(pos.coords.latitude, pos.coords.longitude),
        () => initMap(defaultLat, defaultLng)
      );
    } else {
      initMap(defaultLat, defaultLng);
    }
  }, []);

  // Update solar data every second
  useEffect(() => {
    if (!coords.lat || !coords.lng) return;

    const updateSolarInfo = () => {
      const now = new Date();
      const sunPos = SunCalc.getPosition(now, coords.lat, coords.lng);
      const times = SunCalc.getTimes(now, coords.lat, coords.lng);

      setSolarData({
        time: now.toLocaleTimeString(),
        altitude: (sunPos.altitude * (180 / Math.PI)).toFixed(2), // degrees
        azimuth: (sunPos.azimuth * (180 / Math.PI)).toFixed(2), // degrees
        sunrise: times.sunrise.toLocaleTimeString(),
        sunset: times.sunset.toLocaleTimeString(),
        solarNoon: times.solarNoon.toLocaleTimeString(),
        dayLength: `${Math.floor((times.sunset - times.sunrise) / 3600000)}h ${Math.floor(((times.sunset - times.sunrise) % 3600000) / 60000)}m`
      });
    };

    updateSolarInfo();
    const interval = setInterval(updateSolarInfo, 1000);
    return () => clearInterval(interval);
  }, [coords]);

  return (
    <>
     <Accessibility/>
     <div style={{ display: "flex", gap: "20px", padding: "10px" }}>
     
      <div style={{ flex: 2 }}>
        
        {loading && <p>Fetching location...</p>}
        <div
          id="mapid"
          style={{
            height: "700px",
            width: "100%",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        ></div>
      </div>

      <div
        style={{
          flex: 1,
          background: "#22222257",
          color: "#fff",
          borderRadius: "8px",
          padding: "15px",
          height: "500px",
        }}
      >
        <h3>🌞 Solar Information</h3>
        {solarData.time && (
          <ul style={{ listStyle: "none", padding: 0, lineHeight: "1.8em" }}>
            <li><strong>Current Time:</strong> {solarData.time}</li>
            <li><strong>Altitude:</strong> {solarData.altitude}°</li>
            <li><strong>Azimuth:</strong> {solarData.azimuth}°</li>
            <li><strong>Sunrise:</strong> {solarData.sunrise}</li>
            <li><strong>Solar Noon:</strong> {solarData.solarNoon}</li>
            <li><strong>Sunset:</strong> {solarData.sunset}</li>
            <li><strong>Day Length:</strong> {solarData.dayLength}</li>
          </ul>
        )}
      </div>
    </div>
    </>
    
  );
}
